import moment from "moment";

export function getRoleName(uType) {
  if (uType == 779 || uType == "779") return "Super Admin";
  if (uType == 777 || uType == "777") return "Super Admin";
  if (uType == 7773 || uType == "7773") return "CWW DCF";
  if (uType == 7772 || uType == "7772") return "CWW MH";
  if (uType == 7771 || uType == "7771") return "CWW Clerk";
  if (uType == 774 || uType == "774") return "DFO";
  if (uType == 7742 || uType == "7742") return "DFO MH";
  if (uType == 7741 || uType == "7741") return "DFO Clerk";
  if (uType == 772 || uType == "772") return "Applicant";
  return "Official";
}

export function getCurrentlyWith(item) {
  if (!item) return "";

  if (item.superAdminApprovalStatus === "Success") {
    return "Sanctioned";
  }
  if (item.status === "Cancelled" || item.cancelRequest === "Yes") {
    return "Cancelled";
  }
  if (item.divisonApprovalStatus === "rejected" || item.superAdminApprovalStatus === "rejected") {
    return "Rejected";
  }
  if (item.finalSubmit !== "true" && item.finalSubmit !== true) {
    return "With: Applicant (Draft)";
  }

  // If forwardTo is populated as an object
  if (item.forwardTo && typeof item.forwardTo === "object") {
    const uType = item.forwardTo.uType;
    const name = item.forwardTo.username || item.forwardTo.name;
    const office = item.forwardTo.officeName;
    const roleStr = getRoleName(uType);

    if (office && roleStr && roleStr !== "Official") {
      return `With: ${roleStr} (${office})`;
    } else if (name && roleStr) {
      return `With: ${roleStr} (${name})`;
    } else if (roleStr) {
      return `With: ${roleStr}`;
    } else if (name) {
      return `With: ${name}`;
    }
  }

  // Seat number ("7741@<office path>") names the role even when forwardTo isn't populated.
  if (typeof item.forwardSeat === "string" && item.forwardSeat.indexOf("@") > 0) {
    const seatRole = getRoleName(item.forwardSeat.split("@")[0]);
    if (seatRole !== "Official") {
      const office =
        seatRole !== "CWW Clerk" && seatRole !== "CWW DCF" && seatRole !== "CWW MH" && seatRole !== "Super Admin" &&
        item.campid && item.campid.divisionid && item.campid.divisionid.officeName;
      return office ? `With: ${seatRole} (${office})` : `With: ${seatRole}`;
    }
  }

  // Fallback inferences if forwardTo is not populated or null
  if (item.divisonApprovalStatus === "Success" && item.superAdminApprovalStatus === "Pending") {
    return "With: CWW / Super Admin";
  }
  if (item.divisonApprovalStatus === "Pending") {
    if (item.campid && item.campid.divisionid && item.campid.divisionid.officeName) {
      return `With: Division (${item.campid.divisionid.officeName})`;
    }
    return "With: Division / DFO Clerk";
  }

  return "With: Pending Review";
}

// Payment only becomes due once the application is finally approved, so
// "Payment pending" is shown from then on, not while it is still in review.
// Returns { label, tone } or null (free camp / cancelled / nothing to show).
// tone "neutral" = not due yet; lists hide it, detail pages may show it.
export function paymentBadge(item) {
  if (!item) return null;
  const campType = item.campid && item.campid.campType;
  const isPaidCamp = campType ? campType !== "free" : Number(item.amount) > 0;
  if (!isPaidCamp) return null;
  if (item.paymentStatus === "Success") return { label: "Paid", tone: "success" };
  if (item.status === "Cancelled") return null;
  if (item.divisonApprovalStatus === "rejected" || item.superAdminApprovalStatus === "rejected") return null;
  if (item.superAdminApprovalStatus === "Success") return { label: "Payment pending", tone: "warning" };
  return { label: "Due after approval", tone: "neutral" };
}

// When an application's forwardTo is only an id, take the populated user from
// the matching timeline record (records come from /records/application).
export function withHolderFromRecords(item, records) {
  if (!item || !item.forwardTo || typeof item.forwardTo === "object" || !Array.isArray(records)) return item;
  const holderId = String(item.forwardTo);
  for (let i = records.length - 1; i >= 0; i--) {
    const to = records[i] && records[i].forwardTo;
    if (to && typeof to === "object" && String(to._id) === holderId) {
      return { ...item, forwardTo: to };
    }
  }
  return item;
}

export function getCurrentlyWithBadgeStyle(item) {
  if (!item) return "background-color: #ede7f6; border: 1px solid #b39ddb; max-width: 100%;";

  if (item.superAdminApprovalStatus === "Success") {
    return "background-color: #e8f5e9; border: 1px solid #a5d6a7; max-width: 100%;";
  }
  if (item.status === "Cancelled" || item.cancelRequest === "Yes" || item.divisonApprovalStatus === "rejected" || item.superAdminApprovalStatus === "rejected") {
    return "background-color: #ffebee; border: 1px solid #ffcdd2; max-width: 100%;";
  }
  return "background-color: #ede7f6; border: 1px solid #b39ddb; max-width: 100%;";
}

export function getCurrentlyWithTextStyle(item) {
  if (!item) return "font-size: 11.5px; font-weight: 600; line-height: 1.25; letter-spacing: 0.2px; color: #311b92; text-align: center; word-break: break-word;";

  if (item.superAdminApprovalStatus === "Success") {
    return "font-size: 11.5px; font-weight: 600; line-height: 1.25; letter-spacing: 0.2px; color: #1b5e20; text-align: center; word-break: break-word;";
  }
  if (item.status === "Cancelled" || item.cancelRequest === "Yes" || item.divisonApprovalStatus === "rejected" || item.superAdminApprovalStatus === "rejected") {
    return "font-size: 11.5px; font-weight: 600; line-height: 1.25; letter-spacing: 0.2px; color: #b71c1c; text-align: center; word-break: break-word;";
  }
  return "font-size: 11.5px; font-weight: 600; line-height: 1.25; letter-spacing: 0.2px; color: #311b92; text-align: center; word-break: break-word;";
}

export function getCurrentlyWithIcon(item) {
  if (!item) return "mdi-account-clock";
  if (item.superAdminApprovalStatus === "Success") {
    return "mdi-check-decagram";
  }
  if (item.status === "Cancelled" || item.cancelRequest === "Yes" || item.divisonApprovalStatus === "rejected" || item.superAdminApprovalStatus === "rejected") {
    return "mdi-cancel";
  }
  return "mdi-account-clock";
}

export function getCurrentlyWithIconColor(item) {
  if (!item) return "#311b92";
  if (item.superAdminApprovalStatus === "Success") {
    return "#1b5e20";
  }
  if (item.status === "Cancelled" || item.cancelRequest === "Yes" || item.divisonApprovalStatus === "rejected" || item.superAdminApprovalStatus === "rejected") {
    return "#b71c1c";
  }
  return "#311b92";
}

export function getCurrentlyWithColor() {
  return "deep-purple darken-3";
}

export function formatDate(date) {
  if (!date) return "N/A";
  return moment(date).format("DD-MM-YYYY");
}

export function formatDateTime(date) {
  if (!date) return "N/A";
  return moment(date).format("DD-MM-YYYY hh:mm A");
}
